import { memo } from 'react';
import { Typography } from '@mui/material';
import { getShowById } from '@client/selectors/entities/shows';
import { useInstanceSelector } from '@client/hooks/redux.hooks';
import { getDateTime } from '@sda/utils/date';
import { INTERPUNCT } from '../constants';

interface ShowDateProps {
  readonly showId: string;
}

export const ShowDate = memo<ShowDateProps>(({ showId }) => {
  const show = useInstanceSelector(getShowById, showId);

  return (
    <Typography
      variant="body1"
      component="span"
      display="inline"
    >
      {' '}

      {INTERPUNCT}

      {' '}

      {getDateTime(show.startTime).toFormat('MMM d, yyyy')}
    </Typography>
  );
});
